import React from "react";
import { Card } from "react-bootstrap";
import {
  ClassResponse,
  ContentProviderResponse,
} from "../../services/api.response.service";
import { getLanguageByDefault } from "../../services/app.service";

export interface ClassInfoCardProps {
  data: ClassResponse | ContentProviderResponse;
  className?: string;
}

const OverviewInfoCard = ({ data, className = "" }: ClassInfoCardProps) => {
  const getLanguage = getLanguageByDefault();
  const isContentProviderResponse =
    Object(data).hasOwnProperty("whitelabelled");

  let tagItems: { [key: string]: any }[] = [];

  if (!isContentProviderResponse) {
    const overviewData = data as ClassResponse;
    tagItems = [
      {
        label: getLanguage.category,
        value: overviewData?.category?.name ?? "NA",
      },
      { label: getLanguage.language, value: overviewData?.language ?? "NA" },
      {
        label: getLanguage.learningPartner,
        value: overviewData?.content_provider?.name ?? "NA",
        showLogo: true,
        logo: overviewData?.content_provider?.logo_url ?? "",
      },
    ];
  }

  return (
    <Card className={`class-info-card ${className}`.trim()}>
      <Card.Body className="p-3 p-md-4">
        <h4 className="class-info-card__title mb-3 fw-bold">
          {isContentProviderResponse && (
            <img
              src={data?.logo || data?.logo_url}
              alt={data.name}
              height={50}
              width={50}
            />
          )}
          {data?.name}
        </h4>

        <div className="class-info-card__tags d-flex flex-wrap gap-2 mb-3">
          {!isContentProviderResponse &&
            tagItems.map((item, index) => (
              <div
                key={index}
                className="class-info-card__tag course-card-container px-3 py-2"
              >
                <small className="class-info-card__tag-label text-muted d-block">
                  {item.label}
                </small>
                <span className="class-info-card__tag-value d-flex align-items-center gap-1">
                  {item.showLogo && (
                    <img
                      src={item?.logo || item?.logo_url}
                      alt={item.label}
                      height={20}
                      width={20}
                    />
                  )}
                  {item.value}
                </span>
              </div>
            ))}
        </div>

        <hr className="ec-hr my-3" />

        <div>
          <h5 className="class-info-card__about-title fw-bold mb-2">
            {!isContentProviderResponse
              ? getLanguage.aboutThisClass
              : getLanguage.aboutThisLearningPartner}
          </h5>
          <p className="class-info-card__about-text text-muted mb-0 details-fw">
            {data?.description ?? "NA"}
          </p>
        </div>
      </Card.Body>
    </Card>
  );
};

export default OverviewInfoCard;
